/**
 * Industry slugs — MUST match slightercrm/src/services/business-profile.service.ts
 * INDUSTRY_OPTIONS so a template assigned here lines up with the industry the
 * tenant picks during onboarding.
 */
export const INDUSTRY_OPTIONS: { value: string; label: string; group: string }[] = [
  { value: 'restaurant', label: 'Restaurant', group: 'Food & Hospitality' },
  { value: 'cafe', label: 'Cafe', group: 'Food & Hospitality' },
  { value: 'bakery', label: 'Bakery', group: 'Food & Hospitality' },
  { value: 'software', label: 'Software', group: 'Technology' },
  { value: 'it_services', label: 'IT Services', group: 'Technology' },
  { value: 'agency', label: 'Agency', group: 'Technology' },
  { value: 'digital_marketing', label: 'Digital Marketing', group: 'Technology' },
  { value: 'mobile_shop', label: 'Mobile Shop', group: 'Retail & Electronics' },
  { value: 'mobile_repair', label: 'Mobile Repair', group: 'Retail & Electronics' },
  { value: 'electronics', label: 'Electronics', group: 'Retail & Electronics' },
  { value: 'appliances', label: 'Appliances', group: 'Retail & Electronics' },
  { value: 'furniture', label: 'Furniture', group: 'Retail & Electronics' },
  { value: 'home_decor', label: 'Home Decor', group: 'Retail & Electronics' },
  { value: 'fashion', label: 'Fashion', group: 'Retail & Electronics' },
  { value: 'clothing_brand', label: 'Clothing Brand', group: 'Brands & Manufacturing' },
  { value: 'cosmetics_brand', label: 'Cosmetics Brand', group: 'Brands & Manufacturing' },
  { value: 'manufacturer', label: 'Manufacturer', group: 'Brands & Manufacturing' },
  { value: 'beauty_salon', label: 'Beauty Salon', group: 'Beauty & Wellness' },
  { value: 'spa', label: 'Spa', group: 'Beauty & Wellness' },
  { value: 'barber_shop', label: 'Barber Shop', group: 'Beauty & Wellness' },
  { value: 'healthcare', label: 'Healthcare', group: 'Health & Medical' },
  { value: 'clinic', label: 'Clinic', group: 'Health & Medical' },
  { value: 'hospital', label: 'Hospital', group: 'Health & Medical' },
  { value: 'dental', label: 'Dental', group: 'Health & Medical' },
  { value: 'pharmacy', label: 'Pharmacy', group: 'Health & Medical' },
  { value: 'real_estate', label: 'Real Estate', group: 'Real Estate' },
  { value: 'property_rental', label: 'Property Rental', group: 'Real Estate' },
  { value: 'education', label: 'Education', group: 'Education' },
  { value: 'tutoring', label: 'Tutoring', group: 'Education' },
  { value: 'coaching', label: 'Coaching', group: 'Education' },
  { value: 'online_course', label: 'Online Course', group: 'Education' },
  { value: 'fitness', label: 'Fitness', group: 'Fitness & Sport' },
  { value: 'gym', label: 'Gym', group: 'Fitness & Sport' },
  { value: 'yoga_studio', label: 'Yoga Studio', group: 'Fitness & Sport' },
  { value: 'travel_agency', label: 'Travel Agency', group: 'Travel & Hospitality' },
  { value: 'hotel', label: 'Hotel', group: 'Travel & Hospitality' },
  { value: 'car_rental', label: 'Car Rental', group: 'Travel & Hospitality' },
  { value: 'ecommerce', label: 'E-commerce', group: 'Commerce' },
  { value: 'retail', label: 'Retail', group: 'Commerce' },
  { value: 'grocery', label: 'Grocery', group: 'Commerce' },
  { value: 'professional_services', label: 'Professional Services', group: 'Professional' },
  { value: 'legal', label: 'Legal', group: 'Professional' },
  { value: 'accounting', label: 'Accounting', group: 'Professional' },
  { value: 'consulting', label: 'Consulting', group: 'Professional' },
  { value: 'automotive', label: 'Automotive', group: 'Automotive' },
  { value: 'car_dealership', label: 'Car Dealership', group: 'Automotive' },
  { value: 'event_planning', label: 'Event Planning', group: 'Events' },
  { value: 'wedding', label: 'Wedding', group: 'Events' },
  { value: 'catering', label: 'Catering', group: 'Events' },
  { value: 'courier', label: 'Courier', group: 'Logistics & Delivery' },
  { value: 'logistics', label: 'Logistics', group: 'Logistics & Delivery' },
  { value: 'telecom', label: 'Telecom', group: 'Communications' },
  { value: 'internet_provider', label: 'Internet Provider', group: 'Communications' },
  { value: 'other', label: 'Other', group: 'Other' },
];
